import { Api } from "../service/api/Api";
import { GameLogic } from "onearm";
import { GameMath } from "onearm";
import { BetsController } from "onearm";
import { PaysTableService } from "../features/PaysTableService";
import { AutoplayController } from "onearm";
import { FullscreenService } from "onearm";

export const GameServices = {
    gameMath: { Service: GameMath },
    api: { Service: Api },
    gameLogic: { Service: GameLogic },
    paysTableService: { Service: PaysTableService },
    autoplay: { Service: AutoplayController },
    bets: { Service: BetsController },
    fullscreen: { Service: FullscreenService },
};
